module.exports = __webpack_public_path__ + "static/media/4.36b9b250.png";